export default __webpack_public_path__ + "static/media/test_attempt.35a4b32d.svg";